/**
 * Bundle/pack picker: syncs the add-to-cart button label with the selected
 * pack's price, updates the savings badge to a percentage, and pushes
 * bundle_option_viewed / bundle_option_selected / add_to_cart events to
 * window.dataLayer. Reads its data straight off data-analytics-* attributes
 * rendered by sections/main-product.liquid.
 */
(function () {
  function formatMoney(cents, currencyCode) {
    var amount = Number(cents) / 100;
    if (isNaN(amount)) return '';
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: currencyCode || 'EUR',
      }).format(amount);
    } catch (error) {
      return '€' + amount.toFixed(2).replace('.', ',');
    }
  }

  function pushToDataLayer(payload) {
    if (!window.dataLayer) return;
    window.dataLayer.push(payload);
  }

  function readAnalytics(input) {
    if (!input) return null;
    var data = input.dataset;
    return {
      bundle_variant_id: data.analyticsVariantId,
      bundle_quantity: data.analyticsQuantity,
      bundle_days_supply: data.analyticsDaysSupply,
      bundle_price: data.analyticsPrice ? Number(data.analyticsPrice) / 100 : null,
      bundle_price_per_day: data.analyticsPricePerDay ? Number(data.analyticsPricePerDay) / 100 : null,
      bundle_discount_percent: data.analyticsDiscountPercent || null,
      bundle_recommended: data.analyticsRecommended === 'true',
    };
  }

  function localizedSavingsPrefix() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('nl') === 0) return 'Bespaar';
    if (lang.indexOf('de') === 0) return 'Spare';
    if (lang.indexOf('fr') === 0) return 'Économisez';
    return 'Save';
  }

  function getSavingsPrefix(savings) {
    if (savings.dataset.savingsPrefix) return savings.dataset.savingsPrefix;

    var cleaned = (savings.textContent || '')
      .replace(/[€$£]?\s*\d[\d.,\s]*\s*(?:%|€|EUR|£|\$)?/gi, '')
      .replace(/%+/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    savings.dataset.savingsPrefix = cleaned || localizedSavingsPrefix();
    return savings.dataset.savingsPrefix;
  }

  function updateSavingsLabels(root) {
    root.querySelectorAll('input[data-analytics-discount-percent]').forEach(function (input) {
      var percent = input.dataset.analyticsDiscountPercent;
      if (!percent) return;

      var card = input.closest('.product-detail__price-holder');
      var savings = card && card.querySelector('.product-detail__savings');
      if (!savings) return;

      savings.textContent = getSavingsPrefix(savings) + ' ' + percent + '%';
    });
  }

  function initBundlePicker(root) {
    var sectionId = root.dataset.section;
    var form = document.getElementById('product-form-' + sectionId);
    if (!form) return;

    var addButton = form.querySelector('[name="add"]');
    var currency = root.dataset.currency;
    var viewedVariantIds = {};

    function updateButtonLabel(input) {
      if (!addButton || !input || addButton.hasAttribute('disabled')) return;
      var priceCents = input.dataset.analyticsPrice;
      var label = addButton.dataset.addToCartLabel;
      var labelNode = addButton.querySelector('.product-detail__btn-label');
      if (!priceCents || !label || !labelNode) return;
      labelNode.textContent = label + ' – ' + formatMoney(priceCents, currency);
    }

    function currentChecked() {
      return root.querySelector('input[name="Aantal"]:checked');
    }

    updateSavingsLabels(root);

    if (addButton) {
      new MutationObserver(function () {
        if (!addButton.hasAttribute('disabled')) updateButtonLabel(currentChecked());
      }).observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
    }

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.name !== 'Aantal' || !input.dataset.analyticsVariantId) return;

      updateButtonLabel(input);
      updateSavingsLabels(root);
      pushToDataLayer(
        Object.assign({ event: 'bundle_option_selected' }, readAnalytics(input))
      );
    });

    form.addEventListener('submit', function () {
      pushToDataLayer(
        Object.assign({ event: 'add_to_cart' }, readAnalytics(currentChecked()))
      );
    });

    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var input = entry.target.querySelector('input[name="Aantal"]');
          if (!input || viewedVariantIds[input.dataset.analyticsVariantId]) return;
          viewedVariantIds[input.dataset.analyticsVariantId] = true;
          pushToDataLayer(
            Object.assign({ event: 'bundle_option_viewed' }, readAnalytics(input))
          );
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    root.querySelectorAll('.product-detail__price-holder').forEach(function (card) {
      observer.observe(card);
    });
  }

  document.querySelectorAll('variant-radios[data-section]').forEach(initBundlePicker);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('variant-radios[data-section]');
    if (root) initBundlePicker(root);
  });
})();
